import React, { Component } from 'react';
import { Row, Col, Button, Table, Popconfirm, Tooltip, Select, Checkbox, Pagination } from 'antd';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { api, app } from "../../app";
import utils from "../../utils";
import ReviewSearch from "../../components/ReviewSearch"
import common from "./common2"

const Option = Select.Option;

class ReCardLost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRowKeys: [],
            auditList: [],
            total: 0,
            page: 1,
            dataType: '1',
            search_type: 'searchform_name',
            search_val: '',
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.dataSource(1);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 设置值
     * @param data
     */
    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    /**
     * 数据源
     */
    dataSource = async (page = 1) => {
        await this.setState({ page, data_loading: true });
        let { dataType, search_type, search_val } = this.state, params = {
            page,
            search_val,
            search_type,
            type: dataType,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        };
        let { flag, data, msg, total } = await app.post(api.LostEquipList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            await this.setData({
                selectedRowKeys: [],
                data_loading: false,
                auditList: utils.addArrayKey(data),
                total: parseInt(total || 0),
            });
        }
    }

    /**
     * 页码修改
     * @param page
     */
    handlePageChange = async (page) => {
        await this.dataSource(page);
    }

    /**
     * 全选
     * @param e
     * @returns {Promise<void>}
     */
    handleAllSel = async (e) => {
        let checked = e.target.checked;
        let selectedRowKeys = [];
        if (checked) {
            selectedRowKeys = _.range(1, this.state.auditList.length + 1);
        }
        await this.setData({ selectedRowKeys });
    }

    /**
     * 批量审核
     * @param type
     */
    handlePLReview = async (type) => {
        let { selectedRowKeys, auditList, page, total } = this.state, len = selectedRowKeys.length;
        if (len === 0) {
            app.alert('请选择审核内容', 'warn');
            return;
        }
        let tp = parseInt((total - len) / 20);
        tp = (total - len) % 20 === 0 ? tp : tp + 1;
        if (tp >= page) {
            tp = page;
        }
        let id = selectedRowKeys.map(index => auditList[index - 1].rid).join(',');
        let reviewInfo = {
            id,
            uri: api.LostEquipAudit,
            id_key: "id",
            source: () => this.dataSource(tp),
        };
        if (type === 1) {
            this.props.successReview(1, "", reviewInfo);
        } else if (type === 2) {
            this.props.failReview(reviewInfo);
        }
    }

    /**
     * 搜索
     * @param search_type
     * @param search_val
     */
    handleSearch = async (search_type, search_val) => {
        await this.setData({ search_type, search_val })
        await this.dataSource()
    }

    render() {
        let { data_loading, auditList, total, page, selectedRowKeys, dataType } = this.state,
            tp = parseInt((total - 1) / 20);
        tp = (total - 1) % 20 === 0 ? tp : tp + 1;
        if (tp >= page) {
            tp = page;
        }
        let columns = [
            {
                title: '姓名',
                dataIndex: 'vname',
                key: 'vname',
                width: '10%'
            },
            {
                title: '队员编号',
                dataIndex: 'bsrno',
                key: 'bsrno',
                width: '10%'
            },
            {
                title: '所属队伍',
                dataIndex: 'teamname',
                key: 'teamname',
                width: '15%'
            },
            {
                title: '挂失时间',
                dataIndex: 'submit_time',
                key: 'submit_time',
                width: '12%',
                render: (text) => {
                    return (
                        <span>{text || '无记录'}</span>
                    )
                }
            },
            {
                title: '购买时间',
                dataIndex: 'send_pay_date',
                key: 'send_pay_date',
                width: '14%',
                render: (text) => {
                    return (
                        <span>{text || '无记录'}</span>
                    )
                }
            },

            {
                title: '一级审核',
                dataIndex: 'team_header_audit',
                key: 'team_header_audit',
                width: '8%',
                render: (team_header_audit, { team_header_name, team_header_time, detail, status }) =>
                    common.tableStatus(team_header_audit, team_header_name, team_header_time, detail, status, 1)
            },
            {
                title: '二级审核',
                dataIndex: 'admin_audit',
                key: 'admin_audit',
                width: '8%',
                render: (admin_audit, { admin_name, admin_time, detail, status }) =>
                    common.tableStatus(admin_audit, admin_name, admin_time, detail, status, 2)
            },
            // {
            //     title: '管理员审核',
            //     dataIndex: 'admin_audit',
            //     key: 'admin_audit',
            //     width: '14%',
            //     render: (audit, { admin_name, admin_time, detail }) => common.tableStatus(audit, admin_name, admin_time, detail)
            // },
            {
                title: '挂失原因',
                dataIndex: 'reason',
                key: 'reason',
                width: '10%',
                render: (text) => {
                    return (
                        <Tooltip title={text} trigger="click" mouseLeaveDelay={0.4} arrowPointAtCenter={true}>
                            <span style={{ cursor: 'pointer', color: '#008dff' }}>查看原因</span>
                        </Tooltip>
                    )
                }
            },
        ], rowSelection = null;
        if (dataType === '1') {
            columns.push({
                title: '操作',
                dataIndex: 'rid',
                key: 'rid',
                width: 130,
                render: (id) => {
                    let reviewInfo = {
                        id,
                        uri: api.LostEquipAudit,
                        id_key: "id",
                        source: () => this.dataSource(tp),
                    };
                    let disabled = selectedRowKeys.length > 1;
                    return (
                        <Row type="flex" justify="end">
                            <Popconfirm placement="bottom"
                                title="确定审核通过吗？"
                                cancelText="取消"
                                okText="确定"
                                onConfirm={async () => {
                                    this.props.successReview(1, "", reviewInfo)
                                }}
                            >
                                <Button size="small" type="primary" style={{ marginRight: 20 }}
                                    disabled={disabled}>通过</Button>
                            </Popconfirm>
                            <Button size="small" type="danger" onClick={() => {
                                this.props.failReview(reviewInfo)
                            }} disabled={disabled} ghost>不通过</Button>
                        </Row>
                    )
                }
            });
            rowSelection = {
                selectedRowKeys,
                onChange: async (selectedRowKeys) => {
                    await this.setData({ selectedRowKeys });
                }
            };
        }
        // else {
        //     columns.splice(7, 0, {
        //         title: '省管理员审核',
        //         dataIndex: 'admin_audit',
        //         key: 'admin_audit',
        //         width: '14%',
        //         render: (audit, { admin_name, admin_time, detail }) => common.tableStatus(audit, admin_name, admin_time, detail)
        //     });
        // }
        return (
            <div style={{ height: '100%' }}>
                <div>
                    <span>审核状态： </span>
                    <Select defaultValue="1" style={{ width: 120, marginBottom: 20 }} onChange={async (value) => {
                        await this.setData({ dataType: value });
                        await this.dataSource();
                    }}>
                        <Option value="1">未审核</Option>
                        <Option value="2">已审核</Option>
                    </Select>
                    <ReviewSearch onSearch={this.handleSearch} />
                </div>
                <Table columns={columns}
                    locale={app.tbLocale(data_loading)}
                    dataSource={auditList}
                    loading={data_loading}
                    scroll={{ y: 'calc(100% - 103px)' }}
                    style={{ height: 'calc(100% - 52px)' }}
                    rowSelection={rowSelection}
                    pagination={false}
                    footer={() => {
                        return (
                            <Row hidden={auditList.length === 0}>
                                <Col span={10}>
                                    <div hidden={dataType === '2'}>
                                        <Checkbox
                                            checked={auditList.length !== 0 && auditList.length === selectedRowKeys.length}
                                            onChange={this.handleAllSel}>全选</Checkbox>
                                        <Button style={{ margin: '0 20px' }} type="primary"
                                            onClick={() => this.handlePLReview(1)}>通过</Button>
                                        <Button type="danger" onClick={() => this.handlePLReview(2)}>不通过</Button>
                                    </div>
                                </Col>
                                <Col span={14} style={{ textAlign: 'right' }}>
                                    <Pagination total={total} size="small" pageSize={20} current={page}
                                        showTotal={(total) => `总数量：${total}`}
                                        onChange={this.handlePageChange} />
                                </Col>
                            </Row>
                        );
                    }}
                    size="small"
                />
            </div>
        );
    }
}

ReCardLost.propTypes = {
    successReview: PropTypes.func.isRequired,   //审核通过处理
    failReview: PropTypes.func.isRequired,  //审核失败处理
}

export default ReCardLost;



// WEBPACK FOOTER //
// ./src/routes/review/ReCardLost.jsx